.grid {
  padding-top: 8px;
  padding-bottom: 32px;
}

.list {
  max-height: 40vh;
  overflow-y: auto;
  padding-bottom: 96px;
  /*
   * GH #1163: `mask-image` on a scrolling container re-composites the entire
   * scrolling layer every animation frame on mobile (4x CPU-throttle traces
   * showed dropped frames during touch-scroll). The fade-out is purely
   * decorative — replaced with an inset box-shadow that is a property of the
   * container itself, not the content, so it does not invalidate per scroll.
   */
  box-shadow: inset 0 -40px 24px -24px var(--tuna-palette-background-default);
  /* Hint mobile compositor to keep the list on its own layer. */
  will-change: scroll-position;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}
